import { LocaleKeys } from '../../../../locale/translation-types'

export enum OutingDurationEnum {
  HALF_DAY = 'HALF_DAY',
  FULL_DAY = 'FULL_DAY'
}

export const outingDurationEnumMapping: Record<OutingDurationEnum, LocaleKeys> = {
  [OutingDurationEnum.HALF_DAY]: 'outing.duration.enum.HALF_DAY',
  [OutingDurationEnum.FULL_DAY]: 'outing.duration.enum.FULL_DAY'
}
